module.exports = __webpack_public_path__ + "static/img/11.7f61212.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/11.png
// module id = a6Sd
// module chunks = 35